module.exports = __webpack_public_path__ + "img/shutterstock_590870102-490x340.d13740a8.jpg";